export default __webpack_public_path__ + "static/media/13_photo.4503cd9d.jpg";